module.exports = __webpack_public_path__ + "img/2.cdd17b4c.webp";